import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { BixiFormItemComponent } from './form-item.component';

const COMPONENTS = [BixiFormItemComponent];

@NgModule({
  imports: [CommonModule, NzFormModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class BixiFormModule {
}
